import Accessories from './Accessories.vue'

export default Accessories
